
import { mapActions, mapGetters } from "vuex";
import Form from "./Form.vue";
import IdentificadorData from "./IdentificadorData";

export default {
  name: "app-identificador-update",
  data() {
    return {
      identificador: new IdentificadorData({}),
    };
  },
  components: {
    Form,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getIdentificador(id_identificador) {
      try {
        const { data } = await this.$http.post("/identificador/find", {
          id_identificador: id_identificador,
        });
        return data;
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const codigo = this.$route.params.id_identificador;

        this.setLoading(true);

        const identificador = await this.getIdentificador(codigo);

        this.setLoading(false);

        if (!identificador.id_identificador || identificador == null) {
          this.$router.push({ name: "identificadoresLista" });
          return this.$toast.error("Identificador não encontrado!");
        }

        this.identificador = new IdentificadorData(identificador);
      } catch {
        return;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getInit();
  },
};
